import { render, staticRenderFns } from "./allPack.vue?vue&type=template&id=04a5326e&"
import script from "./allPack.vue?vue&type=script&lang=js&"
export * from "./allPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports